import { themeUi } from '../../themeUi/themeUi';

export const radiusAndShadow = {
  boxShadow: themeUi.core.shadow.shadow4,
  backgroundColor: themeUi.semantic.color.background.secondary0
};
